<template>
    <div class="bump-selector">
        <form class="bump-selector__inner" @submit.prevent="save">
            <div class="bump-selector__control">
                <CustomSelect
                    :model-value="modelValue"
                    compact
                    :options="bumps"
                    :placeholder="$t('pause.bump.placeholder')"
                    emit-prop="id"
                    :empty-text="$t('pause.bump.empty')"
                    :form-value-text="item => item.name[$i18n.locale]"
                    @update:model-value="onSelected"
                    @clear="clear"
                >
                    <template v-slot:default="{ item }">
                        <SmallPlayer
                            :src="item.audio"
                            :active="active === item.audio"
                            @playing="setPlaying"
                            @paused="setPlaying"
                        />
                        <span style="line-height:1;">
                            {{ item.name[$i18n.locale] }}
                        </span>
                    </template>
                </CustomSelect>
            </div>
        </form>
    </div>
</template>

<script>
import { CustomSelect } from '@speechki-frontend/shared/ui/forms';
import { SmallPlayer } from '@speechki-frontend/shared/ui/Player';

export default {
    name: 'BumpSelector',
    components: {
        CustomSelect,
        SmallPlayer
    },
    props: {
        bumps: {
            type: Array,
            default: () => []
        },
        type: {
            type: Object,
            required: true
        },
        modelValue: {}
    },
    emits: ['update:modelValue'],
    data() {
        return {
            active: null
        };
    },
    methods: {
        setPlaying({ src }) {
            this.active = src;
        },

        onSelected(bump) {
            this.$emit('update:modelValue', bump);
        },

        clear() {
            this.$emit('update:modelValue', null);
        }
    }
};
</script>

<style lang="scss" src="./BumpSelector.scss"></style>
